<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${resellerInvoice.code}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="resellerInvoice" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "resellerInvoice-view-logs",

  components: { LogListTable },

  props: ["resellerInvoice"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
